import axios from "axios";
import store from "@/store/index.js";
import { router } from "@/router";

const api = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/api/v1`,
  timeout: 60000,
  withCredentials: true,
});

// adding token to header
api.interceptors.request.use((config) => {
  const token = store.getters["auth/accessToken"];

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// refresh token if 401 unauthorized
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // console.log("interceptors", error);
    const originalReq = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalReq._retry
    ) {
      originalReq._retry = true;

      // get new access token
      try {
        const res = await api.post(`/users/refresh`);
        store.commit("setUser", res.data.data.user);
        store.commit("auth/setAccessToken", res.data.data.accessToken);

        // retry original request
        originalReq.headers.Authorization = `Bearer ${res.data.data.accessToken}`;
        return await api(originalReq);
      } catch (refreshErr) {
        console.error(refreshErr);
        store.commit("setUser", null);
        store.commit("auth/setAccessToken", null);
        router.push({ name: "login" });

        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);

const apiPlugin = function install(app) {
  app.config.globalProperties.$api = api;
};

export { api, apiPlugin };
